import { render, staticRenderFns } from "./CaseTypes.vue?vue&type=template&id=08adfb6e&scoped=true"
import script from "./CaseTypes.vue?vue&type=script&lang=js"
export * from "./CaseTypes.vue?vue&type=script&lang=js"
import style0 from "./CaseTypes.vue?vue&type=style&index=0&id=08adfb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08adfb6e",
  null
  
)

export default component.exports